import { Box, Stack, Typography } from '@mui/material';

import { EditorSection } from './EditorSection';
import { EditorCheckboxField } from './fields/EditorCheckboxField';
import { PROPERTY_AD_AMENITY_GROUPS } from './propertyAdAmenities';
import { usePropertyAdEditorNormalization } from './usePropertyAdEditorNormalization';

export const FeaturesAmenitiesSection = () => {
  const { changeAmenity } = usePropertyAdEditorNormalization();

  return (
    <EditorSection
      description='Select the features and amenities available at the property'
      title='Features & Amenities'
      titleId='features-amenities-title'
    >
      <Box
        sx={{
          columnGap: { xs: 0, md: 4 },
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
          minWidth: 0,
          rowGap: 3,
          width: '100%',
        }}
      >
        {PROPERTY_AD_AMENITY_GROUPS.map((group, groupIndex) => {
          const titleId = `amenity-group-${groupIndex}`;

          return (
            <Stack key={group.title} aria-labelledby={titleId} component='section' minWidth={0}>
              <Typography
                component='h3'
                id={titleId}
                sx={{
                  color: 'rgba(42, 56, 66, 0.5)',
                  fontSize: 12,
                  fontWeight: 600,
                  lineHeight: '20px',
                  margin: '0 0 8px',
                }}
                variant='inherit'
              >
                {group.title}
              </Typography>
              <Stack minWidth={0}>
                {group.options.map((option) => (
                  <EditorCheckboxField
                    key={option.field}
                    label={option.label}
                    name={option.field}
                    onValueChange={(value) => changeAmenity(option.field, value)}
                  />
                ))}
              </Stack>
            </Stack>
          );
        })}
      </Box>
    </EditorSection>
  );
};
